import React from "react";
import translations from "../../translation"; // Import translations

const RecentActivity = ({ content, language }) => {
  // Function to translate static text
  const translate = (key) => translations[language][key] || key;

  return (
    <div className="bg-white shadow-lg rounded-lg overflow-hidden mt-6">
      {/* Static text updated using translation */}
      <div className="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-200 to-gray-200 text-gray">
        <h3 className="text-lg font-semibold">{translate("recentActivityTitle")}</h3>
        <p className="text-sm opacity-90">{translate("recentActivitySubtitle")}</p>
      </div>
      <div className="divide-y divide-gray-200">
        <ul className="divide-y divide-gray-100">
          {/* Dynamic content remains untouched */}
          {content && content.length > 0 ? (
            content.map((activity) => (
              <li key={activity.id} className="p-4 hover:bg-gray-50 transition">
                <div className="flex items-center">
                  <div
                    className={`h-10 w-10 flex items-center justify-center rounded-full shadow-inner ${
                      activity.status === "Approved"
                        ? "bg-green-100 text-green-600"
                        : activity.status === "Rejected"
                        ? "bg-red-100 text-red-600"
                        : "bg-gray-100 text-gray-600"
                    }`}
                  >
                    {activity.status === "Approved" && (
                      <i className="fas fa-check"></i>
                    )}
                    {activity.status === "Rejected" && (
                      <i className="fas fa-times"></i>
                    )}
                    {activity.status === "Pending" && (
                      <i className="fas fa-clock"></i>
                    )}
                  </div>
                  <div className="ml-4 flex-1">
                    <p className="text-sm font-medium text-gray-900">
                      {translate(activity.status)}{" "}
                      <span className="font-bold">{activity.title}</span>
                    </p>
                    <p className="text-xs text-gray-500">
                      {new Date(activity.updated_at).toLocaleString()}
                    </p>
                  </div>
                  <time
                    className="text-xs text-gray-400 ml-auto whitespace-nowrap"
                    dateTime={activity.updated_at}
                  >
                    {new Date(activity.updated_at).toLocaleTimeString()}
                  </time>
                </div>
              </li>
            ))
          ) : (
            // Static text updated using translation
            <li className="p-4 text-center text-gray-500">
              {translate("noRecentActivity")}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default RecentActivity;
